module.exports = __webpack_public_path__ + "static/media/Pretzel Girl.01b66150.jpg";